import { CircularProgress, Typography } from '@mui/material';
import React from 'react';

export const LoadingCount = ({ loading, value }) => {
  return (
    <>
      {loading ? (
        <CircularProgress color="inherit" size={10} />
      ) : (
        <Typography>{value}</Typography>
      )}
    </>
  );
};
